import React from 'react';
import { Outlet, useLoaderData } from 'react-router-dom';

export default function GetMerchant() {
  const loaderData = useLoaderData();
  const { data } = loaderData;
  return <Outlet context={data} />;
}
